import { combineReducers } from 'redux';
import {
  createStatusReducers,
  createMultipleLifeCycleConstants,
  createReducer,
} from 'store/utils/reducerHelpers'
import types from './types'

const initialTheme = {
  "colors": {
    "primary": "#ff5e02",
    "secondary": "#323232",
    "error": "#ff4b4c",
    "success": "#b7e12e",
    "facebook": "#2c6ab3",
    "instagram": "#ee2a7b",
    "twitter": "rgb(30,161,243)",
    "red": "#DB2828",
    "orange": "#F2711C",
    "yellow": "#FBBD08",
    "olive": "#B5CC18",
    "green": "#21BA45",
    "teal": "#00B5AD",
    "blue": "#2185D0",
    "violet": "#6435C9",
    "purple": "#A333C8",
    "pink": "#E03997",
    "brown": "#A5673F",
    "black": "#1B1C1D",
    "blackBorder": "#222426",
    "white": "#FFFFFF",
    "almostWhite": "#F5F5F5",
    "whiteGrey": "#F8F6F8",
    "whiteMegaMenu": "#f0efef",
    "whiteMegaMenuMajor": "#e0e0e0",
    "grey": "#767676",
    "darkGrey": "#5a5a5a",
    "lightGrey": "#e2e2e2",
    "veryLightGrey": "#f7f7f7",
    "greyInactive": "#b2b2b2",
    "greyActive": "#949393",
    "greyStaticPrice": "#979797",
    "greyNoContent": "#AAAAAA",
    "greyBorder": "#dddddd"
  },
  "fonts": {
    "primary": {
      "fontFamily": "Roboto",
      "fontFilePath": "https://fonts.googleapis.com/css?family=Roboto:400,700,400italic,700italic&subset=latin"
    },
    "sizes": {
      "h1": {
        "mini": "2.5em",
        "tiny": "2.5em",
        "small": "2.5em",
        "medium": "2.5em",
        "large": "2.5em",
        "big": "2.5em",
        "huge": "2.5em",
        "massive": "2.5em"
      },
      "h2": {
        "mini": "1.7857142857142858em",
        "tiny": "1.7857142857142858em",
        "small": "1.7857142857142858em",
        "medium": "1.7857142857142858em",
        "large": "1.7857142857142858em",
        "big": "1.7857142857142858em",
        "huge": "1.7857142857142858em",
        "massive": "1.7857142857142858em"
      },
      "h3": {
        "mini": "1.5em",
        "tiny": "1.5em",
        "small": "1.5em",
        "medium": "1.5em",
        "large": "1.5em",
        "big": "1.5em",
        "huge": "1.5em",
        "massive": "1.5em"
      },
      "h4": {
        "mini": "1.2142857142857142em",
        "tiny": "1.2142857142857142em",
        "small": "1.2142857142857142em",
        "medium": "1.2142857142857142em",
        "large": "1.2142857142857142em",
        "big": "1.2142857142857142em",
        "huge": "1.2142857142857142em",
        "massive": "1.2142857142857142em"
      },
      "h5": {
        "mini": "1.1428571428571428em",
        "tiny": "1.1428571428571428em",
        "small": "1.1428571428571428em",
        "medium": "1.1428571428571428em",
        "large": "1.1428571428571428em",
        "big": "1.1428571428571428em",
        "huge": "1.1428571428571428em",
        "massive": "1.1428571428571428em"
      },
      "p": {
        "mini": "1.0714285714285714em",
        "tiny": "1.0714285714285714em",
        "small": "1.0714285714285714em",
        "medium": "1.0714285714285714em",
        "large": "1.0714285714285714em",
        "big": "1.0714285714285714em",
        "huge": "1.0714285714285714em",
        "massive": "1.0714285714285714em"
      },
      "span": {
        "mini": "0.6428571428571429em",
        "tiny": "0.7857142857142857em",
        "small": "0.9285714285714286em",
        "medium": "1.0714285714285714em",
        "large": "1.2142857142857142em",
        "big": "1.3571428571428572em",
        "huge": "1.5em",
        "massive": "1.6428571428571428em"
      },
      "button": {
        "mini": "0.9285714285714286em",
        "tiny": "0.9285714285714286em",
        "small": "0.9285714285714286em",
        "medium": "1.0714285714285714em",
        "large": "1.0714285714285714em",
        "big": "1.0714285714285714em",
        "huge": "1.0714285714285714em",
        "massive": "1.0714285714285714em"
      },
      "a": {
        "mini": "0.9285714285714286em",
        "tiny": "0.9285714285714286em",
        "small": "0.9285714285714286em",
        "medium": "1.0714285714285714em",
        "large": "1.0714285714285714em",
        "big": "1.0714285714285714em",
        "huge": "1.0714285714285714em",
        "massive": "1.0714285714285714em"
      }
    }
  },
  "mediaQuery": {
    "tablet": 768,
    "desktop": 992,
    "wideScreen": 1200
  },
  "megaMenu": {
    "backgroundColor": "#FFFFFF"
  },
  "navContainer": {
    "secondFontColor": "#F2711C",
    "hoverBackGroundColor": "#FFFFFF"
  },
  "verticalNav": {
    "hoverFontColor": "#F2711C",
    "hoverBackGroundColor": "#FFFFFF"
  },
  "personalInfo": {
    "titleFontStyle": {
      "color": "grey"
    },
    "descriptionFontStyle": {
      "color": "black"
    },
    "changePasswordFontStyle": {
      "color": "primary"
    },
    "changePasswordModalTitleGridStyle": {
      "textAlign": "left",
      "color": "primary",
      "bold": true
    },
    "changePasswordModalTitleFontStyle": {
      "color": "primary",
      "bold": true
    }
  }
}

const THEME = createMultipleLifeCycleConstants(types)

const data = createReducer(
  initialTheme,
  {
    [THEME.fetchTheme.success]: (
      (state, action) => {
        return action.payload.theme
      }
    )
  }
)

const statusReducers = createStatusReducers(types)

export default combineReducers({
  data,
  ...statusReducers,
})



// WEBPACK FOOTER //
// ./src/store/theme/reducer.js